import { Dispatch, SetStateAction } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';

interface ConfirmationProps {
  message: string;
  onClick: () => void;
  show: boolean;
  setShow: Dispatch<SetStateAction<boolean>>;
}

export default function Confirmation({
  message,
  onClick,
  show,
  setShow,
}: ConfirmationProps) {
  const { t } = useTranslation();

  const handleClose = () => setShow(false);

  const handleYes = () => {
    setShow(false);
    onClick();
  };

  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>{t('Confirmation')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{t(message)}</Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={handleClose}>
          {t('No')}
        </Button>
        <Button variant="primary" onClick={handleYes}>
          {t('Yes')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
